import React from 'react';

import {Stack, Typography} from '@mui/material';
import {AlertInfo} from 'presentation/components';
import {NetworkHeaderProps} from './types';

export function NetworkHeader({description, title}: NetworkHeaderProps) {
	return (
		<Stack gap={1}>
			<Typography variant="subtitle1" color="text.secondary" fontWeight={600}>
				{title}
			</Typography>
			<AlertInfo.Root>
				<AlertInfo.Description>{description}</AlertInfo.Description>
			</AlertInfo.Root>
		</Stack>
	);
}
